import { Navigate } from "react-router-dom";

export function FirmwareReleaseNoteNewPage(): JSX.Element {
  return <Navigate to="/engineering/firmware?tab=notes&new=1" replace />;
}
